import { FC } from "react";
import { ConfigProvider, Segmented } from "antd";

import styles from "./index.less";

import { PricingPeriodEnum } from "../types";

interface PricingHeaderProps {
  period: PricingPeriodEnum;
  onTogglePeriod: (period: PricingPeriodEnum) => void;
}

const PricingHeader: FC<PricingHeaderProps> = ({ period, onTogglePeriod }) => {
  return (
    <div className={styles.header}>
      <div className={styles.title}>
        <div>为您的团队选择</div>
        <div className={styles.highlight}>最佳的付费方案</div>
      </div>
      <div className={styles.description}>
        按年付费，最高可节省
        <span className={styles.highlight}> 17%</span>
      </div>

      <div className={styles.segmented}>
        <ConfigProvider
          theme={{
            components: {
              Segmented: {
                itemSelectedBg: "#383533",
                itemSelectedColor: "#fff",
                trackBg: "transparent",
                itemHoverColor: "#383533",
                itemHoverBg: "transparent",
                itemColor: "#383533",
                itemActiveBg: "#F3EDE1",
              },
            },
          }}
        >
          <Segmented
            block
            shape="round"
            size="large"
            value={period}
            options={[
              { label: "按月", value: PricingPeriodEnum.MONTHLY },
              { label: "按年", value: PricingPeriodEnum.YEARLY },
            ]}
            onChange={onTogglePeriod}
          />
        </ConfigProvider>
      </div>
    </div>
  );
};

export default PricingHeader;
